/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Carousel accessibility: keep the duplicate product image link out of the tab order, and keep the
 * non-button "Choose Infusion" control in sync with its slide's visibility.
 */
(function () {
  var HIDE_SELECTOR = '.ProductItem__ImageWrapper[aria-hidden="true"]'; // always tabindex="-1"
  // tabindex 0 when visible, -1 while inside an aria-hidden region.
  // ADA item 15: Judge.me badge stars (.jdgm-prev-badge__stars) get focus in off-screen carousel slides — mirror them too.
  var MIRROR_SELECTOR = '.Choose_Infusion, .jdgm-prev-badge__stars';
  var scheduled = false;

  function setTabindex(el, value) {
    if (el.getAttribute('tabindex') !== value) {
      el.setAttribute('tabindex', value);
    }
  }

  function sweep() {
    scheduled = false;
    var hide = document.querySelectorAll(HIDE_SELECTOR), i;
    for (i = 0; i < hide.length; i++) {
      setTabindex(hide[i], '-1');
    }
    var mirror = document.querySelectorAll(MIRROR_SELECTOR);
    for (i = 0; i < mirror.length; i++) {
      setTabindex(mirror[i], mirror[i].closest('[aria-hidden="true"]') ? '-1' : '0');
    }
  }

  function schedule() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    setTimeout(sweep, 0);
  }

  function start() {
    sweep();

    if (typeof MutationObserver === 'function') {
      new MutationObserver(schedule).observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['tabindex', 'aria-hidden']
      });
    }

    $(document).on('init reInit breakpoint setPosition afterChange edge', schedule);
    $(document).on('product:added cart:refresh', schedule);
    $(window).on('load', schedule);
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    $(start);
  }
})();

// Footer accordion

$(".Mobile_Accordion .accordion-content").hide(); 
$(".Mobile_Accordion .accordion-title").click(function(){
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
    $('.Mobile_Accordion .accordion-content').slideUp('500','linear');
    $('.Mobile_Accordion .accordion-title').not(this).removeClass('active');
    $('.Mobile_Accordion .Footer__Block--links').removeClass('activeToggle');
    $(this).addClass('active');
    $(this).next('.Mobile_Accordion .accordion-content').slideDown('500','linear');
    $(this).parent().addClass("activeToggle"); 
  } else {
    $(this).removeClass('active');
    $(this).next('.Mobile_Accordion .accordion-content').slideUp('500','linear');
    $(this).parent().removeClass("activeToggle");
  }
});

$(document).ready(function(){
  
  $('.Related_Articles').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });


  $('.logo__list--inner').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });  

  $('.Collection_List').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          centerMode: true
        }

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          centerMode: true
        }
      }
    ]
  });  
  
  $('.Linklist__Item a:contains("On Sale")').addClass('On_Sale');
  
  jQuery('.Open_Drawer, .Close_Drawer').click(function(){
    jQuery(".Collection_Info_Drawer").toggleClass('active');
    jQuery(".PageOverlay").toggleClass('is-visible');
    jQuery("html, body").toggleClass('active-drawer');
  });
  
  jQuery('.PageOverlay').click(function(){
    jQuery(".Collection_Info_Drawer").removeClass('active');
    jQuery(".PageOverlay").removeClass('is-visible');
    jQuery("html, body").removeClass('active-drawer');
  });

  $('.swatch-dropdown-qty').click(function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.list--infusion').slideUp(200);
      
    } else {
      $(this).addClass('active');
      $('.list--infusion').slideDown(200);
    
    }
  });

  $('.list--infusion .HorizontalList__Item').click(function() {
    var text = $(this).find('.ColorSwatchLabel').text();
    $('.list--infusion .HorizontalList__Item').removeClass('selected-variant');
    $(this).addClass('selected-variant');
    var get_price = $('.get-price[data-variant="'+ text +'"]').data('price');
    var get_compare_price = $('.get-compare-price[data-variant="'+ text +'"]').data('compare-price');
    $('.ProductMeta__Price').html(get_price);
    $('.Price--compareAt').html(get_compare_price);
    var th = $(this).find('.ColorSwatch');
    var st = th.attr('style');
    if(th.hasClass('ColorSwatch_Sold')){
      var html = '<label class="ColorSwatch ColorSwatch--large ColorSwatch_Sold" style="'+st+'"><span class="u-visually-hidden">'+text+'</span><span class="ColorSwatchLabel body-3">'+text+' - Sold Out</span></label>';    	
    }
    else{
      var html = '<label class="ColorSwatch ColorSwatch--large" style="'+st+'"><span class="u-visually-hidden">'+text+'</span><span class="ColorSwatchLabel body-3">'+text+'</span></label>';    	
    }
    $('.swatch-dropdown-qty p').html(html);
    $('.swatch-dropdown-qty').removeClass('active');
    $('.list--infusion').slideUp(200);
  });

  $(".Product__Info .accordion-block:not(:first-child) .accordion-content").hide(); 
  $(".Product__Info .accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.Product__Info .accordion-content').slideUp('500','linear');
      $('.Product__Info .accordion-title').not(this).removeClass('active');
      $('.Product__Info .accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.Product__Info .accordion-content').slideDown('500','linear');
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.Product__Info .accordion-content').slideUp('500','linear');
      $(this).parent().removeClass("activeToggle"); 	
    }
  });

  //ProductForm__AddToCart
  $(document).on('click','.ProductForm__AddToCart', function(e){
     e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var form = $(this).closest('form');
    var v = form.find('[name="id"]').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      }
    }).done(function( data ) {
      console.log("success",data.product_id);
      var add_id = data.product_id;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: Number(v),
          quantity: 1
        }
      }));
      $('.Cart_You_Like_Wrapper .ProductItem').each(function(index){
        $(this).find('[data-pid="' + add_id + '"]').parent().addClass('in-cart');
        $('.Cart_Product_Item:not(.in-cart)').removeClass('hide');
        $('.Cart_Product_Item:not(.in-cart):gt(9)').addClass('hide');
      });
      window.add_addon_product();
      window.cart_progress_bar();
    });
  });

  $(document).on('click','.CartItem__Remove',function(){
    var get_id = $(this).data('lid');
     setTimeout(function() {
      $('.Cart_You_Like_Wrapper .ProductItem').each(function(index){
        $(this).find('[data-pid="' + get_id + '"]').parent().removeClass('in-cart');
        $('.Cart_Product_Item:not(.in-cart)').removeClass('hide');
        $('.Cart_Product_Item:not(.in-cart):gt(9)').addClass('hide');
      })
     },400);
  })
  
  $('.You_May_Also_Like_Section .ProductList').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          centerMode: true
        }
      }
    ]
  });
  
  $('#filter-opt .Linklist__Item').on('click', function(e){
    e.preventDefault();
    $('#filter-opt .Linklist__Item').removeClass('selected');
    $(this).addClass('selected');
    var th = $(this);
    setTimeout(function(){
      th.closest('.Collapsible').find('button.Collapsible__Button').trigger('click');
      th.closest('.Collapsible').find('button.Collapsible__Button span').html(th.find('a').html());
    },50);
  });
  
  if (window.matchMedia('(min-width: 769px)').matches){
    $(window).scroll(function() {
      var windscroll = $(window).scrollTop();
      if (windscroll >= 100) {
        $('.Faq .Faq__Section').each(function(i) {
          if (($(this).position().top)-100 <= windscroll) {
            $('.FaqSummary li.is-active').removeClass('is-active');
            $('.FaqSummary li').eq(i).addClass('is-active');
          }
        });
      } else {
        $('.FaqSummary li.is-active').removeClass('is-active');
        $('.FaqSummary li:first').addClass('is-active');
      }
    }).scroll();
  }
  
});

if($('.Product__SlideshowNavImage').length >= 4){
  
  $('.Product__SlideshowNavScroller').slick({
    arrow: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: false,
    variableWidth: false,
    prevArrow:"<button type='button' class='slick-prev pull-left'><span class='visually-hidden'>Previous slide</span><svg xmlns='http://www.w3.org/2000/svg' width='37' height='69' viewBox='0 0 37 69' fill='none'><path d='M35 2L2 35.5L35 67.5' stroke='#4d5b5b' stroke-width='4' stroke-linecap='square'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><span class='visually-hidden'>Next slide</span><svg xmlns='http://www.w3.org/2000/svg' width='37' height='69' viewBox='0 0 37 69' fill='none'><path d='M2 67L35 33.5L2 1.5' stroke='#4d5b5b' stroke-width='4' stroke-linecap='square'/></svg></button>"
  });
  
}

if($('.Product__SlideshowNavImage').length >= 4){

  $(window).on("load resize orientationchange", function(event){
    
    if (window.matchMedia('(max-width: 1200px)').matches){
      $('.Product__SlideshowNavScroller').slick({
        arrow: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        variableWidth: false,
        prevArrow:"<button type='button' class='slick-prev pull-left'><span class='visually-hidden'>Previous slide</span><svg xmlns='http://www.w3.org/2000/svg' width='37' height='69' viewBox='0 0 37 69' fill='none'><path d='M35 2L2 35.5L35 67.5' stroke='#4d5b5b' stroke-width='4' stroke-linecap='square'/></svg></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><span class='visually-hidden'>Next slide</span><svg xmlns='http://www.w3.org/2000/svg' width='37' height='69' viewBox='0 0 37 69' fill='none'><path d='M2 67L35 33.5L2 1.5' stroke='#4d5b5b' stroke-width='4' stroke-linecap='square'/></svg></button>"
      });
    }
    
  });

}

jQuery(document).ready(function(jQuery){

  // ADA item 9: "Choose Infusion" is exposed as role="button" with aria-expanded. Keep the
  // attribute in sync when the infusion panel opens/closes, support Escape, and return focus.
  function closeInfusionPanels($except) {
    jQuery('.Show_On_Hover.active').each(function () {
      if ($except && jQuery(this).is($except)) { return; }
      jQuery(this).removeClass('active');
    });
    jQuery('.Choose_Infusion[aria-expanded="true"]').each(function () {
      if ($except && jQuery(this).next('.Show_On_Hover').is($except)) { return; }
      jQuery(this).attr('aria-expanded', 'false');
    });
  }

  $('body').on('click', '.ProductItem .ProductItem__Wrapper .ProductItem__Info .Choose_Infusion', function() {
    var $panel = jQuery(this).next(".Show_On_Hover");
    var isOpen = $panel.hasClass('active');
    closeInfusionPanels();
    if (!isOpen) {
      $panel.addClass('active');
      jQuery(this).attr('aria-expanded', 'true');
    }
  });

  // role="button" needs Enter/Space to activate, and Escape to close + return focus to the toggle.
  $('body').on('keydown', '.ProductItem .ProductItem__Wrapper .ProductItem__Info .Choose_Infusion', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      $(this).trigger('click');
    } else if (e.key === 'Escape' || e.keyCode === 27) {
      $(this).next('.Show_On_Hover').removeClass('active');
      $(this).attr('aria-expanded', 'false');
    }
  });

  // Escape while focus is inside the open panel closes it and returns focus to the toggle.
  $('body').on('keydown', '.ProductItem .ProductItem__Wrapper .ProductItem__Info .Show_On_Hover', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var $toggle = jQuery(this).prev('.Choose_Infusion');
      jQuery(this).removeClass('active');
      $toggle.attr('aria-expanded', 'false').focus();
    }
  });

  jQuery(document).mouseup(function (e) {
    var menu1 = jQuery('.Show_On_Hover');
    if (!menu1.is(e.target) && menu1.has(e.target).length === 0)
    {

      menu1.removeClass('active');
      jQuery('.Choose_Infusion[aria-expanded="true"]').attr('aria-expanded', 'false');
    }
  });

  $('body').on('click','.Mobile_Search', function(e){
    e.preventDefault();
    setTimeout(function(){
      $('#search-drawer').attr('aria-hidden', 'false');
      $('#Search1').attr('aria-hidden','false');
      $('.PageOverlay').addClass('is-visible');
    },100);
  });
  
  $('.back-menu, .PageOverlay').on('click', function(e){
    e.preventDefault();;
    $('#search-drawer').attr('aria-hidden', 'true');
    $('.PageOverlay').removeClass('is-visible');
    $('#Search1').attr('aria-hidden','true');
  });
  
  $('#Search1 .Search_Mobile_Close').on('click', function(e){
    e.preventDefault();
    $('#Search1').find('.Search__Input').val('');
    $('#Search1').find('.Search__Results').attr('aria-hidden','true');
    
  });
  
  $('#address_form_new').on('submit', function(e){
    setTimeout(function(){
      location.href="/account";    
    },1000);
  });
  
  $('.delete-icon').on('click', function(e){
    setTimeout(function(){
      location.href="/account";
    },1000);
  });
  
  $('body').on('mouseover','.ColorSwatch', function(e){
  	var t = $(this).attr('title');
    $(this).closest('.ProductItem').find('.color-name').html(t);
  });
  
  $('body').on('click', '.ProductItem__ColorSwatchItem .ColorSwatch', function(e){
    if($(this).closest('.ProductItem__ColorSwatchItem').hasClass('soldout')){
      $(this).closest('.ProductItem').find('.ProductForm__AddToCart span').html('Sold Out');
      $(this).closest('.ProductItem').find('.ProductForm__AddToCart').attr('disabled', true);
    }
    else
    {
      $(this).closest('.ProductItem').find('.ProductForm__AddToCart span').html('Add to cart');
      $(this).closest('.ProductItem').find('.ProductForm__AddToCart').attr('disabled', false);
    }
  });
  
  var url = location.href;
  if(url.indexOf('?variant=') != -1){}
  else{
    if($('.ColorSwatchList .HorizontalList__Item:first').hasClass('is-hidden')){
      $('.ColorSwatchList .HorizontalList__Item:first').next().find('label').trigger('click');
    }
    else{
      $('.ColorSwatchList .HorizontalList__Item:first').find('label').trigger('click');
    }
  }
  
});

$(window).on('load', function(){
  var alt = $('.HorizontalList__Item.is-hidden input').val();
  $('.Product__SlideshowNavScroller').slick('slickRemove',$('.Product__SlideshowNavScroller .Product__SlideshowNavImage img[alt="'+ alt +'"]').closest('.slick-slide').attr('data-slick-index'));
  $('.Cart_Product_Item:not(.in-cart)').removeClass('hide');
  $('.Cart_Product_Item:not(.in-cart):gt(9)').addClass('hide');
});

$(window).on("load resize orientationchange", function(){
  var t = $("body").width(),
      i = 1280,
      s = t - i,
      a = s / 2;
  if(a < 80){
    var f_a = 80;

  } else {
    var f_a = a;      
  }
  $(".Slideshow__Content").css("padding-right", f_a);
});

$(window).on("load resize orientationchange", function(){
  var t = $("body").width(),
      i = 1280,
      s = t - i,
      a = s / 2;
  if(a < 80){
    var f_a = 80;

  } else {
    var f_a = a;      
  }
  $(".Slideshow__Content").css("padding-left", f_a);
});

$(".Header__Icon").click(function(){
  $("#smile-ui-container").css("z-index", 9);
});

function Sliders () {
  var $window_width = window.innerWidth;
  if ($window_width < 769) {
    $(".Five_Grid_Collection_List").not('.slick-initialized').slick({
      dots: false,
      arrows: false,
      centerMode: true,
      slidesToShow: 1,
      infinite: true,
      centerPadding: '40px',
      speed: 300
    });

    $(".Tab_Content_Slider ").not('.slick-initialized').slick({ 
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: '70px',
      slidesToShow: 3,
      responsive: [
		{
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 3
          }
        },
		{
          breakpoint: 640,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1
          }
        }
      ]
    })

  }
  else {
    if($(".Five_Grid_Collection_List").hasClass('slick-initialized')){
      $(".Five_Grid_Collection_List").slick('unslick');
    }

    if($(".Tab_Content_Slider").hasClass('slick-initialized')){
      $(".Tab_Content_Slider").slick('unslick');
    }
  }
}

$(window).resize(function() {
  $('.ProductItem__Title').matchHeight({ byRow: true });
  $('.Text_Icon_Content').matchHeight({ byRow: false });
});

$(document).ready(function() {

  Sliders ();

  $('.ProductItem__Title').matchHeight({ byRow: true });
  $('.Text_Icon_Content').matchHeight({ byRow: false });
  $('.popup__item--title').matchHeight({ byRow: true });

  $('.Product_Slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        }
      }
    ]
  });

  var $item = $('.FaqSummary .Collapsible__Content ul li');
  $item.on('click', 'a', function(event) {
    var $section = $($(this).attr('href'));
    var sectionTop = $section.offset().top - 60;  
    $('html, body').animate({scrollTop: sectionTop }, 700 );
    event.preventDefault();
  });
 
  var $window_width = window.innerWidth;
  
  if ($window_width > 769) {
    var $tab_item = $('.Tabs_Header ol li');	
    $tab_item.on('click', 'a', function(event) {
      if($(this).has('active-tab')){
        $('.Tabs_Header ol li a').removeClass('active-tab');
        $(this).addClass('active-tab');
      }
      var $tab_section = $($(this).attr('href'));
      var Tab_section_Top = $tab_section.offset().top - 150;  
      $('html, body').animate({scrollTop: Tab_section_Top } );
      event.preventDefault();
    });
  }
  
  if ($window_width < 769) {
    var $tab_item = $('.Tabs_Header ol li');	
    $tab_item.on('click', 'a', function(event) {
      if($(this).has('active-tab')){
        $('.Tabs_Header ol li a').removeClass('active-tab');
        $(this).addClass('active-tab');
      }
      var $tab_section = $($(this).attr('href'));
      var Tab_section_Top = $tab_section.offset().top - 80;  
      $('html, body').animate({scrollTop: Tab_section_Top } );
      event.preventDefault();
    });
  }

  $('.ProductItem__Wrapper .ColorSwatch--small').on('touchstart touchend', function(e) {
    e.preventDefault();
    $(this).trigger('click');
    return false;
  });

});

$('.SectionHeader__TabList button').click(function(){
  $('.Product_Slider ').css('display','none');

  setTimeout(function() {
    $('.Product_Slider').slick('refresh');
    $('.Product_Slider').css('display','block');
  },600);
  setTimeout(function() {
    $('.ProductItem__Title').matchHeight({ byRow: true });
  },800);

})

$(window).on("load resize orientationchange", function(event) {
  Sliders(); 
});

$(function () {

  var activeIndex = $('.active-tab').index(),
      $contentlis = $('.tabs-content > div'),
      $tabslis = $('.tabs li');

  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
  });
});

$(function() {
  var list = $('.Custom_Dropdown_List');
  var link = $('.Js_Link');
  
  var mobactiveIndex = $('.active-tab').index(),
      $mobcontentlis = $('.tabs-content > div'),
      $mobtabslis = $('.Custom_Dropdown_List li');

  link.click(function(e) {
    e.preventDefault();
   
    $(this).toggleClass('active');
    list.slideToggle(200);
  });
  
  list.find('li').click(function(e) {    
    var text = $(this).html();
    var icon = '<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="black"/></svg>';
    link.html(text+icon);
    list.slideToggle(200);
    if (text === '* Reset') {
      link.html('Select one option'+icon);
    }

    var $mobcurrent = $(e.currentTarget),
        mobindex = $mobcurrent.index();
    $mobtabslis.removeClass('active-tab');
    $mobcurrent.addClass('active-tab');
    $mobcontentlis.hide().eq(mobindex).show();
  });
});

$(document).on('click','.Collapsible__Content label',function(){
  if ($(window).width() > 769) {
  $('.Collapsible__Button').attr('aria-expanded','false')
}
else {
   $('.Collapsible__Button').attr('aria-expanded','false')
  $('.Drawer__Close').trigger('click');
 }
})

window.add_addon_product= function () {
  // return;
  if(!window.theme.addonproid) return;
  var checkproductstatus = window.theme.checkaddonpdp;
  if(checkproductstatus){
  $.ajax({
  url: '/cart.js',
  type: 'GET',
  async: false, 
  dataType: 'json',
  success: function(cart){
   for(var item in cart.items) {
      var idexist = false;
      var checkShipProdId = window.theme.addonproid;
      if(cart.items[item].id == checkShipProdId ) {
      var idexist = true;
      break;
    }
   }
   var get_threshold = window.theme.addonthreshold;  
    if(get_threshold < cart.items_subtotal_price) {
      if(!idexist) {
       $.ajax({
        url: '/cart/add.js',
        type: 'POST',
         async: false, 
        data:{id:window.theme.addonproid,quantity:1},
        dataType: 'json',
        success: function(data){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
          }));
        },
        error: function(err){
        console.log('error',err);
       }
      })
    }
   }
    else {
      $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        async: false, 
        data:{id:window.theme.addonproid,quantity:0},
        dataType: 'json',
        success: function(data){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
          }));
        },
        error: function(err){
        console.log('error',err);
       }
      })
    }
  },
  error: function(err){
  console.log('error',err);
  }
 })
 }
}
window.add_addon_product();

$(document).ready(function(){
  $('.Cart_Product_Item .ColorSwatch').on('click', function(e){
      var target = $(this).closest('.ProductItem__ColorSwatchItem').find('input[type="radio"]');
      var v = $(this).closest('.ProductItem__ColorSwatchItem').find('input[type="radio"]').attr('data-variantid');
      var url = $(this).closest('.ProductItem__ColorSwatchItem').find('input[type="radio"]').attr('data-variant-url');
      $(this).closest('.Cart_Product_Item').find('a').attr('href', url);
      $(this).closest('.Show_On_Hover').find('form [name="id"]').val(v);
      var originalImageElement = $(this).closest('.Cart_Product_Item').find('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      console.log(originalImageElement,target.attr('data-image-url'),target.attr('data-image-id'));
      if (target.attr('data-image-url') && target.attr('data-image-id') !== originalImageElement.attr('data-image-id')) {
        var newImageElement = document.createElement('img');
        newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
        newImageElement.setAttribute('data-image-id', target.attr('data-image-id'));
        newImageElement.setAttribute('data-src', target.attr('data-image-url'));
        newImageElement.setAttribute('data-widths', target.attr('data-image-widths'));
        newImageElement.setAttribute('data-sizes', 'auto'); // Replace the original node

        if (window.theme.productImageSize === 'natural') {
          $(originalImageElement).closest('.AspectRatio').css('padding-bottom',(100.0 / target.attr('data-image-aspect-ratio'))+'%' );
          // originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.attr('data-image-aspect-ratio'), "%");
        }
        $(originalImageElement).closest('.AspectRatio').css('--aspect-ratio', target.attr('data-image-aspect-ratio'));
        $(originalImageElement).closest('.AspectRatio').html(newImageElement);
        // originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.attr('data-image-aspect-ratio'));
        // originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      }
  });

  if($('body').hasClass('template-index') && $('body').hasClass('customer-wholesale')){
    window.location.href = '/pages/wholesale';
  }

});

document.addEventListener("DOMContentLoaded", () => {
  // First script: Add the `open_in_new_window` custom attribute
  const links = document.querySelectorAll(".fit-content__links a");

  links.forEach(link => {
    link.setAttribute("open_in_new_window", "");
    link.setAttribute("rel", "noopener noreferrer");
  });

  // Second script: Add event listeners to handle `open_in_new_window`
  document.querySelectorAll("[open_in_new_window]").forEach(el => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      try {
        const href = e.currentTarget.getAttribute("href");
        if (!href) {
          console.error("Error: The element does not have a valid 'href' attribute.");
          return;
        }
        const newWindow = window.open(href, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          console.error("Error: Unable to open a new window. Pop-up blocker might be enabled.");
          alert("Failed to open the link. Please check your browser's pop-up settings.");
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  function updateMissingIds() {
    document.querySelectorAll("span[data-id]").forEach(span => {
      if (!span.id || span.id.trim() === "") {
        span.id = span.getAttribute("data-id");
      }
    });
  }

  // Run before the slider initializes
  updateMissingIds();

  // Run again after slider initialization to fix cloned items
  setTimeout(() => {
    updateMissingIds();
  }, 100);

  // Observe DOM changes and update IDs dynamically
  const observer = new MutationObserver(updateMissingIds);
  observer.observe(document.body, { childList: true, subtree: true });

  // Also re-run when the Slick slider updates
  document.addEventListener("slick:change", updateMissingIds);
});



document.querySelectorAll(".toggle").forEach(function(trigger) {
  trigger.addEventListener("click", function() {
    var targetId = this.getAttribute("data-target");
    var modal = document.getElementById(targetId);
    if (modal) {
      modal.classList.add("show-modal");
      document.body.classList.add("overflow-modal");

      // Close Button
      var closeButton = modal.querySelector(".popup__close");
      if (closeButton) {
        closeButton.addEventListener("click", function () {
          modal.classList.remove("show-modal");
          document.body.classList.remove("overflow-modal");
        });
      }

      // Click Outside to Close
      window.addEventListener("click", function handler(event) {
        if (event.target === modal) {
          modal.classList.remove("show-modal");
          document.body.classList.remove("overflow-modal");
          window.removeEventListener("click", handler);
        }
      });
    }
  });
});


(() => {
  /**
   * Parse config like:
   * "Coconut:#36b4e5\nMango: #fea068\n..."
   */
  function parseColorConfig(raw) {
    const map = {};
    const text = (raw ?? "").toString();

    text
      .split(/\r?\n/)                 // break each new line
      .map(l => l.trim())
      .filter(l => l && !l.startsWith("#")) // allow comments if you want
      .forEach(line => {
        const idx = line.indexOf(":");       // break each line with ":"
        if (idx === -1) return;

        const name = line.slice(0, idx).trim();
        const value = line.slice(idx + 1).trim();

        if (!name || !value) return;

        // normalize key for matching
        const key = normalizeName(name);
        map[key] = value;
      });

    return map;
  }

  function normalizeName(s) {
    return String(s || "")
      .replace(/$sold out$/ig, "")
      .replace(/&amp;/ig, "&")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  // Build map from theme setting
  const COLOR_MAP = parseColorConfig(window.COLOR_SWATCH_CONFIG_RAW);

  // Fallback if not found (use your "Assorted" if present, else grey)
  function colorFor(name) {
    const key = normalizeName(name);
    return COLOR_MAP[key] || COLOR_MAP[normalizeName("Assorted")] || "#ccc";
  }

  const ITEM_SEL = ".recharge-bundle-product-item";
  const TRIGGER_SEL = 'div[role="button"][aria-haspopup="listbox"]';
  const HIDDEN_SELECT_SEL = '[data-testid="hidden-select-container"] select';

  function applyToItem(item) {
    const select = item.querySelector(HIDDEN_SELECT_SEL);
    const trigger = item.querySelector(TRIGGER_SEL);
    if (!select || !trigger) return;

    const selectedText =
      select.selectedOptions?.[0]?.textContent?.trim() ||
      trigger.querySelector("span")?.textContent?.trim() ||
      trigger.textContent.trim();

    trigger.style.setProperty("--selected-swatch", colorFor(selectedText));
  }

  function applyAllItems(root = document) {
    root.querySelectorAll(ITEM_SEL).forEach(applyToItem);
  }

  function applyListboxOptions(root = document) {
    root.querySelectorAll('li[role="option"][aria-label]').forEach(li => {
      li.style.setProperty("--swatch", colorFor(li.getAttribute("aria-label")));
    });
  }

  function refresh() {
    applyAllItems(document);
    applyListboxOptions(document);
  }

  refresh();

  document.addEventListener("click", () => setTimeout(refresh, 0), true);
  document.addEventListener("change", () => setTimeout(refresh, 0), true);

  const mo = new MutationObserver(() => refresh());
  mo.observe(document.querySelector("#bundling-app") || document.body, {
    subtree: true,
    childList: true,
    attributes: true
  });
})();

const cartDrawerEl =
  document.querySelector('#sidebar-cart') ||
  document.querySelector('[data-section-type="cart"]') ||
  document.querySelector('[data-drawer]');
const id = cartDrawerEl?.id;
window.RechargeBundle = { 
  onAddToCart: () => { 
    // Open slide cart or trigger a custom action
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
    
    // Open Drawer
    document.querySelector(`[data-action="open-drawer"][data-drawer-id="${id}"]`)?.click();

    // Close Drawer
    // document.querySelector(`[data-action="close-drawer"][data-drawer-id="${id}"]`)?.click();
      
  } 
}

try {
  const faqLink = document.querySelector('a[href="#Custom_Faq_Section"]');

  if (faqLink) {
    faqLink.addEventListener('click', function (e) {
      try {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const target = document.querySelector('#Custom_Faq_Section');
        const header = document.querySelector('header#section-header');

        if (!target) {
          console.warn('Custom_Faq_Section element not found');
          return;
        }

        const headerHeight = header ? header.clientHeight + 5 : 0;

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - headerHeight,
          behavior: 'smooth'
        });

      } catch (error) {
        console.error('FAQ scroll error:', error);
      }
    }, {
      capture: true
    });
  } else {
    console.warn('FAQ link not found');
  }
} catch (error) {
  console.error('FAQ click handler initialization error:', error);
}

/* ------------------------------------------------------------------
   ADA item 29 (interim shim) — Recharge Bundles widget on the Rituals builder
   (/products/curate-your-own-ritual). The widget is Recharge's React app and
   loads @latest, so we patch it from the outside. REMOVE this once Recharge
   ships a proper fix, and RE-TEST after any Recharge update (markup can change).

   Covers, from Recharge-Bundle-Widget-Issues-2026-09-26:
     1  grid with no rows        -> role=grid becomes role=list
     2  list with no list items  -> role=list's role=img slots become role=listitem
     3  tabs' broken aria-controls-> removed when the target panel id doesn't exist
     6  focus lost after Add     -> focus moves to the new qty input / + button
     7  nothing announced on Add -> a polite live region announces the added product
     8  dead Tab stop per card   -> tabindex=0 removed from gridcells
     9  dropdown named "label"   -> given a meaningful accessible name
     10 every Add button is "Add"-> aria-label includes the product name
   Also: Enter/Space activate the non-native (role=button / role=tab) controls.
   Contrast (4) and the qty target size (5) are handled in custom.css.
   ------------------------------------------------------------------ */
(function () {
  var CARD = '.recharge-bundle-product-item';

  function root() { return document.getElementById('bundling-app'); }

  function isVisible(el) {
    return !!el && (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0);
  }

  function visibleQtyInput(card) {
    var inputs = card.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].type !== 'hidden' && isVisible(inputs[i])) { return inputs[i]; }
    }
    return null;
  }

  function productName(card) {
    if (!card) { return ''; }
    var el = card.querySelector('[class*="title" i], [class*="name" i]') ||
             card.querySelector('a[href*="/products/"]');
    var txt = el ? (el.textContent || '') : '';
    return txt.replace(/\s+/g, ' ').trim();
  }

  // ---- live region for "added" announcements (item 7) ----------------
  var liveRegion = null;
  function announce(msg) {
    if (!msg) { return; }
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = msg; }, 30);
  }

  // ---- ARIA/role patch sweep (items 1, 2, 3, 8, 9, 10) --------------
  function patch() {
    var app = root();
    if (!app) { return; }
    try {
      // 1 & 8: grid with no rows + dead gridcell Tab stops.
      app.querySelectorAll('[role="grid"]').forEach(function (g) { g.setAttribute('role', 'list'); });
      app.querySelectorAll('[role="gridcell"]').forEach(function (c) {
        c.setAttribute('role', 'listitem');
        if (c.getAttribute('tabindex') === '0') { c.setAttribute('tabindex', '-1'); }
      });

      // 2: selected-products summary list whose slots are role="img".
      app.querySelectorAll('[role="list"] [role="img"]').forEach(function (s) { s.setAttribute('role', 'listitem'); });

      // 3: tab aria-controls pointing at a panel id that doesn't exist.
      app.querySelectorAll('[role="tab"][aria-controls]').forEach(function (t) {
        var id = t.getAttribute('aria-controls');
        if (id && !document.getElementById(id)) { t.removeAttribute('aria-controls'); }
      });

      // 9: infusion dropdown announced as the placeholder "label".
      app.querySelectorAll('[aria-haspopup="listbox"]').forEach(function (trig) {
        var lbl = (trig.getAttribute('aria-label') || '').trim();
        if (!lbl || lbl.toLowerCase() === 'label') {
          var span = trig.querySelector('span');
          var txt = span ? span.textContent.trim() : '';
          trig.setAttribute('aria-label', (txt && txt.toLowerCase() !== 'label') ? ('Infusion: ' + txt) : 'Choose infusion');
        }
      });

      // 10: every Add button is just "Add" — include the product name.
      app.querySelectorAll(CARD).forEach(function (card) {
        var name = productName(card);
        if (!name) { return; }
        card.querySelectorAll('button, [role="button"]').forEach(function (btn) {
          if (btn.getAttribute('aria-haspopup')) { return; } // skip the infusion trigger
          var label = (btn.getAttribute('aria-label') || btn.textContent || '').replace(/\s+/g, ' ').trim();
          if (/^add$/i.test(label)) { btn.setAttribute('aria-label', 'Add ' + name); }
        });
      });
    } catch (e) { /* never let the shim break the page */ }
  }

  // ---- focus + announce after Add (items 6, 7) ----------------------
  var lastCard = null;

  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest(CARD) : null;
    if (card) { lastCard = card; }
  }, true);

  function focusStepper(card) {
    if (!card || !document.contains(card)) { return; }
    var input = visibleQtyInput(card);
    if (input) { input.focus(); return; }
    var btns = card.querySelectorAll('button, [role="button"]');
    if (btns.length) { btns[btns.length - 1].focus(); } // fall back to the + button
  }

  var scheduled = false;
  function afterMutation() {
    scheduled = false;
    patch();
    if (!lastCard) { return; }
    // Act only once the stepper (a visible qty input) has appeared in the clicked card.
    if (visibleQtyInput(lastCard)) {
      var name = productName(lastCard);
      var ae = document.activeElement;
      // Only move focus if Recharge dropped it to the document body/root.
      if (!ae || ae === document.body || ae === document.documentElement) { focusStepper(lastCard); }
      announce(name ? (name + ' added to your bundle') : 'Product added to your bundle');
      lastCard = null;
    }
  }
  function schedule() { if (!scheduled) { scheduled = true; setTimeout(afterMutation, 60); } }

  if (typeof MutationObserver === 'function') {
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true });
  }
  patch();

  // ---- Enter / Space for non-native role="button" / role="tab" ------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar' && e.keyCode !== 13 && e.keyCode !== 32) { return; }
    var el = e.target;
    if (!el || !el.closest) { return; }
    if (!el.closest(CARD) && !el.closest('[role="tablist"]') && !el.closest('#bundling-app')) { return; }
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'button' || tag === 'a' || tag === 'input' || tag === 'select' || tag === 'textarea') { return; } // native: already works
    var role = el.getAttribute && el.getAttribute('role');
    if (role !== 'button' && role !== 'tab') { return; }
    if (el.getAttribute('aria-haspopup')) { return; } // infusion dropdown already handles Enter
    e.preventDefault();
    el.click();
  }, true);
})();